import React, { useEffect, useState, useRef, useMemo } from "react";
import {
  Button,
  Modal,
  Box,
  Typography,
  Select,
  MenuItem,
  TextField,
  IconButton,
  Chip,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Dialog,
  InputAdornment,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import PlaylistSmallCardComponent from "./PlaylistSmallCardComponent";
import { useDispatch, useSelector } from "react-redux";
import BackgroundImageController from "./BackgroundImageController";
import axios from "axios";
import { setCurrentResolution } from "../../redux/slices/resolutionSlice";
import { setLayout } from "../../redux/slices/layoutSlice";
import { toast } from "react-toastify";
import SearchIcon from "@mui/icons-material/Search";
import ClearIcon from "@mui/icons-material/Clear";
import userEvent from "@testing-library/user-event";
import { useTheme, useMediaQuery } from "@mui/material";


const MyLayoutForm = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [layoutName, setLayoutName] = useState("");
  const dispatch = useDispatch();
  const resolutionsList = useSelector(
    (state) => state?.resolution?.resolutions
  );
  const [resolution, setResolution] = useState(
    resolutionsList?.[0]?.value || ""
  );
  useEffect(() => {
    if (resolutionsList?.[0]?.value) {
      dispatch(setCurrentResolution(resolutionsList[0].value));
    }
  }, [dispatch, resolutionsList]);

  const [containerSize, setContainerSize] = useState({
    width: 640,
    height: 480,
  });
  const [selectedPlaylist, setSelectedPlaylist] = useState(null);
  const playlist = useSelector((state) => state?.playlist?.playlist);
  const eventcustomisations = useSelector(
    (state) => state?.eventcustomisations?.eventcustomisations
  );

  const [targetWidth, setTargetWidth] = useState("640");
  const [targetHeight, setTargetHeight] = useState("480");
  const [isLayoutDialogOpen, setIsLayoutDialogOpen] = useState(false);
  const [tempLayoutName, setTempLayoutName] = useState("");

  useEffect(() => {
    if (resolution) {
      const [width, height] = resolution.split("x").map(Number);
      setTargetWidth(width);
      setTargetHeight(height);
      setContainerSize({ width, height });
    }
  }, []);
  const handleResolutionChange = (event) => {
    const selectedResolution = event.target.value;
    setResolution(selectedResolution);
    dispatch(setCurrentResolution(selectedResolution));

    const [width, height] = selectedResolution.split("x").map(Number);
    setTargetWidth(width);
    setTargetHeight(height);
    setContainerSize({ width, height });
  };

  const preview = useSelector((state) => state.preview);

  const modalClose = () => {
    setIsModalOpen(false);
    setLayoutName("");
    setSelectedPlaylist(null);
    setTempLayoutName("");
  };
  const headers = useSelector((state) => state.header);
  const emmsheaders = useSelector((state) => state.emmsheader);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [errorModalOpen, setErrorModalOpen] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [success, setSuccessMessage] = useState();
  const api = localStorage.getItem("api");
  const curremms = useSelector((state) => state.curremms);
  const selectedOption = curremms.curremms.id;
  const [zoomLevel, setZoomLevel] = useState(1);
  const [imageLeft, setImageLeft] = useState(0);
  const [imageRight, setImageRight] = useState(0);
  const [imageTop, setImageTop] = useState(0);
  const [imageBottom, setImageBottom] = useState(0);
  const [displayProperty, setDisplayProperty] = useState("Width");
  const [firstImageUrl, setFirstImageUrl] = useState("");
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("md"));
  const previewBoxRef = useRef(null);

  const { containerHeight, containerWidth } = useMemo(() => {
    let containerHeight = window.innerHeight * 0.8;
    let containerWidth = window.innerHeight;
    if (isMobile) {
      const width = previewBoxRef.current?.clientWidth || window.innerWidth;
      const height = previewBoxRef.current?.clientHeight || window.innerHeight;

      const size = Math.min(width, height);

      containerHeight = size;
      containerWidth = size;
    }


    return {
      containerHeight,
      containerWidth
    };
  }, [isMobile, previewBoxRef.current?.clientHeight]);

  const layout = useSelector((state) => state?.layout?.layout);
  const scaleX = containerWidth / targetWidth;
  const scaleY = containerHeight / targetHeight;
  const scale = Math.min(scaleX, scaleY);
  const scaledWidth = targetWidth * scale;
  const scaledHeight = targetHeight * scale;
  const [showControls, setShowControls] = useState(true);
  const playlists = useSelector((state) => state?.playlist?.playlist);
  const toggleControls = () => {
    setShowControls((prev) => !prev);
  };
  const user = useSelector((state) => state?.user?.user);
  const templates = useSelector((state) => state?.template?.template);
  const dataToDisplay = useSelector(
    (state) => state?.dataToDisplay?.dataToDisplay
  );
  const [searchQuery, setSearchQuery] = useState("");




  const filteredPlaylist = playlist?.filter((item) =>
    item?.name.toLowerCase().includes(searchQuery?.toLowerCase())
  );
  const handleLayoutNameConfirm = () => {
    setLayoutName(tempLayoutName);
    setIsLayoutDialogOpen(false);
  
  };
  useEffect(() => {
    if (layoutName) {
      handleSubmit(new Event("submit"));
    }
  }, [layoutName]);
  useEffect(() => {
    if (preview?.previewPlaylistObject) {
      setSelectedPlaylist(preview.previewPlaylistObject);
      setFirstImageUrl(
        "https://images.pexels.com/photos/1779487/pexels-photo-1779487.jpeg"
      );
    }
  }, [preview]);

  useEffect(() => {
    if (firstImageUrl && targetWidth && targetHeight) {
      const img = new Image();
      img.src = firstImageUrl;
      img.onload = () => {
        const imageAspectRatio = img.width / img.height;
        const targetAspectRatio = targetWidth / targetHeight;

        if (imageAspectRatio > targetAspectRatio) {
          setDisplayProperty("Width");
        } else {
          setDisplayProperty("Height");
        }
      };
    }
  }, [firstImageUrl, targetWidth, targetHeight]);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!layoutName?.trim()) {
      setIsLayoutDialogOpen(true); 
      return;
    }

    if (!resolution) {
      toast.error("Resolution is required.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    if (!selectedPlaylist) {
      toast.error("Please select a playlist.", {
        position: toast.POSITION.BOTTOM_RIGHT,
      });
      return;
    }

    const payload = {
      name: layoutName,
      resolution,
      playlistId: selectedPlaylist.id,

      bottom: imageBottom.toString(),
      left: imageLeft.toString(),
      right: imageRight.toString(),
      top: imageTop.toString(),
      zoomScale: zoomLevel.toString(),
      customProperties: {
        displayProperty: displayProperty.toString(),
        contentAiLayoutMaker: user.email,
      },
    };

    try {
      const requestBody = {
        path: "layout",
        query: {},
        body: { ...payload },
        emmsId: `${selectedOption}`,
        requestType: "POST",
        headers: {
          ...emmsheaders?.emmsheaders?.headers,
        },
      };

      axios
        .post(api + `/emms/piggyback`, requestBody, headers)
        .then((response) => {
          setIsSubmitting(false);
          const combinedData = [response.data, ...layout];
          dispatch(setLayout(combinedData));

          setErrorModalOpen(true);
          setErrorMessage(`Layout created successfully`);
          setSuccessMessage(true);
          modalClose();
        })
        .catch((error) => {
          setErrorModalOpen(true);
          setErrorMessage(`Error creating template: ${error?.response?.data}`);
          setSuccessMessage(false);
          modalClose();
        });
    } catch (error) {
      console.error("Error creating layout:", error);
      alert("An unexpected error occurred. Please try again.");
      modalClose();
    }
  };

  return (
    <>
      <div>
        <Button
          variant="contained"
          color="primary"
          onClick={() => {
            setIsModalOpen(true)
          }}
          style={{ textTransform: "none" }}
        >
          Create Layout
        </Button>

        <Dialog
          open={isLayoutDialogOpen}
          onClose={() => setIsLayoutDialogOpen(false)}
          maxWidth="xs"
          fullWidth
          PaperProps={{
            style: { borderRadius: 12, padding: "8px 16px" },
          }}
        >
          <DialogTitle>
            <Typography variant="h6" fontWeight="bold">
              Enter Layout Name
            </Typography>
          </DialogTitle>

          <DialogContent>
            <DialogContentText sx={{ mb: 2 }}>
              Please provide a name for your layout.
            </DialogContentText>

            <TextField
              autoFocus
              margin="dense"
              label="Layout Name"
              fullWidth
              variant="outlined"
              value={tempLayoutName}
              onChange={(e) => setTempLayoutName(e.target.value)}
              InputProps={{
                sx: { borderRadius: 2 },
              }}
            />
          </DialogContent>

          <DialogActions
            sx={{ justifyContent: "space-between", padding: "16px" }}
          >
            <Button
              onClick={() => setIsLayoutDialogOpen(false)}
              color="error"
              variant="outlined"
            >
              Cancel
            </Button>
            <Button
              onClick={handleLayoutNameConfirm}
              disabled={!tempLayoutName.trim()}
              color="primary"
              variant="contained"
            >
              Confirm
            </Button>
          </DialogActions>
        </Dialog>

        <Modal open={isModalOpen} onClose={modalClose}>
          <Box
            sx={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: "100vw",
              height: { xs: "100%", md: "100vh" },
              bgcolor: "background.paper",
              boxShadow: 24,
              display: "flex",
              flexDirection: "column",
            }}
          >
            <Box
              sx={{
                padding: 2,
                borderBottom: "1px solid #ddd",
                display: "flex",
                justifyContent: "space-between",
                alignItems: "center",
                bgcolor: "#f4f4f9",
              }}
            >
              <Typography color="primary" variant="h6">
                Elhi Landscape Manager
              </Typography>
            </Box>

            <Box
              sx={{
                display: "flex",
                flexDirection: { xs: "column", md: "row" },
                padding: 2,
                height: "90%",
              }}
            >
              <Box
                sx={{
                  flex: "0.5",
                  display: "flex",
                  flexDirection: "column",

                  height: { xs: "60%", md: "100%" },
                  width: { xs: "100%", md: "70vw" },
                }}
                ref={previewBoxRef}
              >
                <Box sx={{ display: "flex", justifyContent: "space-between", flexDirection: { xs: "column", md: "row" } }}>
                  <div>
                    <Typography
                      variant="body"
                      sx={{
                        mr: { xs: "6px", md: "0px" }
                      }}
                    >
                      Select Resolution
                    </Typography>
                    <Select
                      value={resolution}
                      onChange={handleResolutionChange}
                      sx={(theme) => ({
                        [theme.breakpoints.down("md")]: {
                          "& .MuiSelect-outlined": {
                            paddingTop: "8px",
                            paddingBottom: "8px",
                          },
                        },
                      })}

                    >
                      {resolutionsList?.map((res) => (
                        <MenuItem key={res.id} value={res.value}>
                          {res.name}
                        </MenuItem>
                      ))}
                    </Select>
                  </div>
                  <Button
                    variant="contained"
                    onClick={toggleControls}
                    sx={{ margin: "10px 0", textTransform: "none", width: { xs: "max-content", md: "unset" } }}
                  >
                    {showControls ? "Hide Controls" : "Show Controls"}
                  </Button>
                </Box>

                <div
                  className="newNavigatorRightPreviewScreenContainer"
                  style={{
                    alignSelf: "center",
                    width: `${targetWidth > targetHeight ? containerWidth : scaledWidth
                      }px`,
                    height: `${targetHeight > targetWidth ? containerHeight : scaledHeight
                      }px`,
                    transformOrigin: "center center",
                    overflow: "hidden",
                    backgroundColor: "#404040",
                  }}
                >
                  {selectedPlaylist?.id ? (
                    (() => {
                      const selectedPlaylistData = playlists.find(
                        (playlist) => playlist.id === selectedPlaylist.id
                      );

                      if (!selectedPlaylistData) {
                        return (
                          <Typography
                            variant="body1"
                            style={{ textAlign: "center" }}
                          >
                            Playlist not found.
                          </Typography>
                        );
                      }

                      const item = selectedPlaylistData?.items?.[0];

                      if (!item) return null;

                      const matchedContent = dataToDisplay.find(
                        (data) => data.id === item.content_ref
                      );

                      if (!matchedContent) {
                        return (
                          <div
                            style={{
                              position: "relative",
                              width: "100%",
                              height: "100%",
                              overflow: "hidden",
                              backgroundColor: "grey",
                              marginBottom: "10px",
                              display: "flex",
                              justifyContent: "center",
                              alignItems: "center",
                            }}
                          >
                            <Typography variant="body2">
                              Content not found
                            </Typography>
                          </div>
                        );
                      }

                      const { customProperties, name } = matchedContent;

                      return (
                        <div
                          style={{
                            position: "relative",
                            width: "100%",
                            height: "100%",
                            overflow: "hidden",
                            backgroundColor: "grey",
                            marginBottom: "10px",
                          }}
                        >
                          {customProperties?.html && (
                            <iframe
                              srcDoc={customProperties.html}
                              title={name || "Content"}
                              style={{
                                height: "100%",
                                width: "100%",
                                border: "none",
                              }}
                            />
                          )}

                          {item?.type === "content" &&
                            matchedContent.customisations?.[0]?.imageUrl &&
                            ([".mp4", ".avi", ".mov"].some((ext) =>
                              matchedContent.customisations[0].imageUrl
                                .toLowerCase()
                                .endsWith(ext)
                            ) ? (
                              <video
                                src={matchedContent.customisations[0].imageUrl}
                                controls
                                style={{
                                  height:
                                    displayProperty === "Height"
                                      ? "100%"
                                      : "auto",
                                  width:
                                    displayProperty === "Width" ? "100%" : "auto",
                                  transform: `scale(${zoomLevel})`,
                                  position: "absolute",

                                  top: `${imageTop}%`,
                                  left: `${imageLeft}%`,
                                  bottom: `${imageBottom}%`,
                                  right: `${imageRight}%`,
                                }}
                              />
                            ) : (
                              <img
                                src={matchedContent.customisations[0].imageUrl}
                                alt={name || "Playlist Item"}
                                style={{
                                  height:
                                    displayProperty === "Height"
                                      ? "100%"
                                      : "auto",
                                  width:
                                    displayProperty === "Width" ? "100%" : "auto",
                                  transform: `scale(${zoomLevel})`,
                                  position: "absolute",
                                  top: `${imageTop}%`,
                                  left: `${imageLeft}%`,
                                  bottom: `${imageBottom}%`,

                                  right: `${imageRight}%`,
                                }}
                              />
                            ))}

                          {item?.type === "contentAI" && (
                            <img
                              src={matchedContent.imageUrl}
                              alt={name || "Playlist Item"}
                              style={{
                                height:
                                  displayProperty === "Height" ? "100%" : "auto",
                                width:
                                  displayProperty === "Width" ? "100%" : "auto",
                                transform: `scale(${zoomLevel})`,
                                position: "absolute",
                                top: `${imageTop}%`,
                                left: `${imageLeft}%`,
                                bottom: `${imageBottom}%`,
                                right: `${imageRight}%`,
                              }}
                            />
                          )}
                        </div>
                      );
                    })()
                  ) : (
                    <Typography
                      variant="body1"
                      style={{
                        textAlign: "center",
                        color: "white",
                        marginTop: "25%",
                      }}
                    >
                      Select a playlist
                    </Typography>
                  )}

                  {showControls && (
                    <BackgroundImageController
                      preview={true}
                      imageBottom={imageBottom}
                      imageLeft={imageLeft}
                      imageRight={imageRight}
                      imageTop={imageTop}
                      setimageTop={setImageTop}
                      setimageLeft={setImageLeft}
                      setimageBottom={setImageBottom}
                      setimageRight={setImageRight}
                      setzoomLevel={setZoomLevel}
                      zoomLevel={zoomLevel}
                      setDisplayProperty={setDisplayProperty}
                    />
                  )}
                </div>
              </Box>

              <Box
                sx={{
                  flex: "0.5",
                  display: "flex",
                  flexDirection: "column",
                  height: { xs: "45%", md: "100%" },
                  justifyContent: "space-between",
                }}
              >
                <Box
                  sx={{
                    padding: 2,
                    overflowY: "scroll",

                    height: "90%",
                    "&::-webkit-scrollbar": {
                      width: "6px",
                    },
                    "&::-webkit-scrollbar-thumb": {
                      backgroundColor: "#888",
                      borderRadius: "10px",
                      border: "2px solid transparent",
                      backgroundClip: "padding-box",
                    },
                    "&::-webkit-scrollbar-thumb:hover": {
                      backgroundColor: "#555",
                    },
                    "&::-webkit-scrollbar-track": {
                      backgroundColor: "transparent",
                    },
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      mb: 1,
                    }}
                  >
                    <Chip
                      label="Select Playlist/Content"
                      sx={{
                        fontSize: ".8rem",
                        padding: "4px 12px",
                        borderRadius: "8px",
                        mr: {
                          xs: 0.5,
                          md: "unset"
                        }
                      }}
                    />
                    <TextField
                      size="small"
                      variant="standard"
                      placeholder="Search Playlist..."
                      value={searchQuery}
                      onChange={(e) => setSearchQuery(e.target.value)}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <SearchIcon />
                          </InputAdornment>
                        ),
                        endAdornment: searchQuery && (
                          <InputAdornment position="end">
                            <IconButton
                              onClick={() => setSearchQuery("")}
                              size="small"
                            >
                              <ClearIcon />
                            </IconButton>
                          </InputAdornment>
                        ),
                      }}
                      sx={{ mb: 2 }}
                    />
                  </Box>

                  <PlaylistSmallCardComponent
                    playlist={filteredPlaylist}
                    eventcustomisations={eventcustomisations}
                  />
                </Box>
                <Box
                  sx={{
                    padding: 2,
                    borderTop: "1px solid #ddd",
                    display: "flex",
                    justifyContent: "flex-end",
                    gap: "2rem",
                  }}
                >
                  <Button
                    variant="outlined"
                    onClick={modalClose}
                    color="error"
                    style={{ textTransform: "none" }}
                  >
                    Close
                  </Button>
                  <Button
                    variant="contained"
                    color="primary"
                    style={{ textTransform: "none" }}
                    onClick={handleSubmit}
                  >
                    Create Layout
                  </Button>
                </Box>
              </Box>
            </Box>
          </Box>
        </Modal>
      </div>
    </>
  );
};

export default MyLayoutForm;
